import React, { useState, useEffect, useRef } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { teamData, socialMedia } from '../data/mock';
import { Calendar as CalendarIcon, MapPin, Timer } from 'lucide-react';

const raceEvents = [
  { id: 1, event: "Round 1 Internazionali d'Italia", location: "Alghero", date: new Date("2026-01-31") },
  { id: 2, event: "Round 2 Internazionali d'Italia", location: "Mantova", date: new Date("2026-02-07") },
  { id: 3, event: "Round 1 Campionato Italiano Junior 125", location: "Partanna", date: new Date("2026-03-14") },
  { id: 4, event: "Round 1 Campionato Italiano Prestige MX2", location: "Ottobiano", date: new Date("2026-03-14") },
  { id: 5, event: "Round 1 EMX125 & EMX250", location: "Almonte, Spagna", date: new Date("2026-03-21") },
  { id: 6, event: "Round 2 EMX125 & EMX250", location: "Frauenfeld, Svizzera", date: new Date("2026-03-28") },
  { id: 7, event: "Round 3 EMX125 & EMX250", location: "Riola Sardo, Italia", date: new Date("2026-04-11") },
  { id: 8, event: "Round 4 EMX125 & EMX250", location: "Arco Di Trento, Italia", date: new Date("2026-04-18") },
  { id: 9, event: "Round 2 Campionato Italiano Prestige MX2", location: "Maggiora", date: new Date("2026-05-02") },
  { id: 10, event: "Round 2 Campionato Italiano Junior 125", location: "Ponte Sfondato", date: new Date("2026-05-09") },
  { id: 11, event: "Round 3 Campionato Italiano Prestige MX2", location: "Fermo", date: new Date("2026-05-16") },
  { id: 12, event: "Round 5 EMX250", location: "Teutschental, Germania", date: new Date("2026-05-30") },
  { id: 13, event: "Round 6 EMX125 & EMX250", location: "Kegums, Lettonia", date: new Date("2026-06-06") },
  { id: 14, event: "Round 4 Campionato Italiano Prestige MX2", location: "Arco di Trento", date: new Date("2026-06-13") },
  { id: 15, event: "Round 1 Rookies Cup 125 Junior", location: "Arco di Trento", date: new Date("2026-06-13") },
  { id: 16, event: "Round 7 EMX250", location: "Montevarchi, Italia", date: new Date("2026-06-20") },
  { id: 17, event: "Round 7 EMX125", location: "Agueda, Portogallo", date: new Date("2026-06-27") },
  { id: 18, event: "Round 5 Campionato Italiano Prestige MX2", location: "Faenza", date: new Date("2026-07-11") },
  { id: 19, event: "Round 2 Rookies Cup", location: "Faenza", date: new Date("2026-07-11") },
  { id: 20, event: "Round 8 EMX250", location: "Lommel, Belgio", date: new Date("2026-08-01") },
  { id: 21, event: "Round 9 EMX125", location: "Uddevala, Svezia", date: new Date("2026-08-01") },
  { id: 22, event: "Round 9 EMX250", location: "Arnhem, Netherlands", date: new Date("2026-08-22") },
  { id: 23, event: "Round 3 Campionato Italiano Junior 125", location: "Faenza", date: new Date("2026-08-29") },
  { id: 24, event: "Round 6 Campionato Italiano Prestige MX2", location: "Castiglion del Lago", date: new Date("2026-08-29") },
  { id: 25, event: "EMX125 Round 10", location: "Afyonkarahisar, Turchia", date: new Date("2026-09-05") },
  { id: 26, event: "EMX250 Round 10", location: "Afyonkarahisar, Turchia", date: new Date("2026-09-05") },
  { id: 27, event: "Round 4 Campionato Italiano Junior 125", location: "Alghero", date: new Date("2026-09-12") },
  { id: 28, event: "Round 5 Campionato Italiano Junior 125", location: "Mantova", date: new Date("2026-09-26") }
];

// Countdown Timer Component
const CountdownTimer = ({ raceDate }) => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, isPast: false });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const difference = raceDate - now;
      
      if (difference > 0) {
        // Future race - countdown
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
          isPast: false
        };
      } else {
        // Past race - time since
        const absDifference = Math.abs(difference);
        return {
          days: Math.floor(absDifference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((absDifference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((absDifference / 1000 / 60) % 60),
          seconds: Math.floor((absDifference / 1000) % 60),
          isPast: true
        };
      }
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [raceDate]);

  return (
    <div className={`flex items-center gap-3 flex-wrap ${timeLeft.isPast ? 'opacity-70' : ''}`}>
      <div className="flex items-baseline gap-1">
        <span className="text-3xl font-black text-cyan-400">{timeLeft.days}</span>
        <span className="text-sm text-gray-400">giorni</span>
      </div>
      <span className="text-gray-600">•</span>
      <div className="flex items-baseline gap-1">
        <span className="text-xl font-bold text-white">{timeLeft.hours}</span>
        <span className="text-xs text-gray-500">ore</span>
      </div>
      <span className="text-gray-600">•</span>
      <div className="flex items-baseline gap-1">
        <span className="text-xl font-bold text-white">{timeLeft.minutes}</span>
        <span className="text-xs text-gray-500">min</span>
      </div>
      <span className="text-gray-600">•</span>
      <div className="flex items-baseline gap-1">
        <span className="text-xl font-bold text-white">{timeLeft.seconds}</span>
        <span className="text-xs text-gray-500">sec</span>
      </div>
      <span className={`ml-2 text-sm font-semibold ${timeLeft.isPast ? 'text-gray-500' : 'text-yellow-400'}`}>
        {timeLeft.isPast ? 'fa' : 'mancano'}
      </span>
    </div>
  );
};

const Calendario = () => {
  const now = new Date();
  const eventRefs = useRef([]);
  
  // Auto-scroll to today's or next upcoming race
  useEffect(() => {
    // Find the index of the first future race
    const nextRaceIndex = raceEvents.findIndex(event => event.date >= now);
    
    if (nextRaceIndex !== -1 && eventRefs.current[nextRaceIndex]) {
      // Scroll to the next race with smooth behavior and offset for header
      setTimeout(() => {
        eventRefs.current[nextRaceIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 500);
    } else if (eventRefs.current.length > 0) {
      // If all races are past, scroll to the last race
      const lastIndex = eventRefs.current.length - 1;
      setTimeout(() => {
        eventRefs.current[lastIndex]?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 500);
    }
  }, []);
  
  return (
    <div className="bg-black min-h-screen">
      <Header logo={teamData.logo} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-7xl font-black text-white mb-6">
              Calendario <span className="text-cyan-400">2026</span>
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-yellow-400 mx-auto mb-8"></div>
            <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto">
              Tutte le gare della stagione con countdown in tempo reale
            </p>
          </div>
        </div>
      </section>

      {/* Calendar Events - Timeline Style */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Timeline */}
            <div className="relative">
              {/* Vertical Line */}
              <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-cyan-500 via-yellow-400 to-cyan-500"></div>
              
              {/* Events */}
              <div className="space-y-12">
                {raceEvents.map((event, index) => {
                  const isPast = event.date < now;
                  return (
                    <div
                      key={event.id}
                      ref={el => eventRefs.current[index] = el}
                      className={`relative flex items-center ${
                        index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      } flex-col`}
                    >
                      {/* Timeline Dot */}
                      <div className={`absolute left-8 md:left-1/2 w-5 h-5 rounded-full border-4 border-black transform -translate-x-1/2 z-10 ${
                        isPast 
                          ? 'bg-gray-600 shadow-lg shadow-gray-600/50' 
                          : 'bg-cyan-500 shadow-lg shadow-cyan-500/50 animate-pulse'
                      }`}></div>
                      
                      {/* Event Card */}
                      <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:pr-16' : 'md:pl-16'} pl-20 md:pl-0`}>
                        <div className={`group bg-gradient-to-br from-gray-900 to-gray-800 p-6 rounded-2xl border transition-all duration-300 hover:transform hover:-translate-y-2 ${
                          isPast 
                            ? 'border-gray-700/50 opacity-70' 
                            : 'border-gray-700 hover:border-cyan-500/50'
                        }`}>
                          {/* Event Info */}
                          <div className="flex items-start gap-4 mb-4">
                            <div className={`p-3 rounded-lg flex-shrink-0 ${isPast ? 'bg-gray-600' : 'bg-cyan-500'}`}>
                              <CalendarIcon className="w-6 h-6 text-black" />
                            </div>
                            <div className="flex-1">
                              <span className={`inline-block px-3 py-1 text-xs font-bold rounded-full mb-2 uppercase ${
                                isPast ? 'bg-gray-600 text-gray-300' : 'bg-yellow-500 text-black'
                              }`}>
                                {isPast ? 'Conclusa' : 'Prossima'}
                              </span>
                              <p className="text-cyan-400 font-bold text-lg">
                                {event.date.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}
                              </p>
                            </div>
                          </div>
                          
                          <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
                            {event.event}
                          </h3>
                          
                          <div className="flex items-center gap-2 text-gray-400 mb-4">
                            <MapPin className="w-4 h-4 text-cyan-400 flex-shrink-0" />
                            <span>{event.location}</span>
                          </div>

                          {/* Timer */}
                          <div className={`flex items-center gap-2 p-3 rounded-xl border mt-4 ${
                            isPast ? 'border-gray-700 bg-gray-800/50' : 'border-cyan-500/30 bg-cyan-950/20'
                          }`}>
                            <Timer className={`w-5 h-5 flex-shrink-0 ${isPast ? 'text-gray-500' : 'text-cyan-400'}`} />
                            <CountdownTimer raceDate={event.date} />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-20 text-center">
            <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 backdrop-blur-sm p-10 rounded-3xl border border-gray-700/50 max-w-3xl mx-auto">
              <CalendarIcon className="w-16 h-16 text-cyan-400 mx-auto mb-6" />
              <h3 className="text-3xl font-bold text-white mb-4">
                Resta Aggiornato
              </h3>
              <p className="text-xl text-gray-400 leading-relaxed mb-6">
                Seguici sui nostri canali social per non perdere nessun aggiornamento sulle gare e i risultati del team!
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer socialMedia={socialMedia} teamName={teamData.name} logo={teamData.logo} />
    </div>
  );
};

export default Calendario;
